<div class="content-wrapper">
    <div class="row">
  
  
      <div class="col-lg-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Approval Levels</h4>
            <div class="table-responsive pt-3">
              <table class="table table--striped table-hover">
                <thead>
                  <tr>
                    <th>
                      S/N
                    </th>
  
                    <th>
                    Designation                      </th>
                    <th>
                      Priority                </th>
                    <th>
                        Approval By Function?
                    </th>
                    <th>
                      Approval By Location?
                  </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let data of rRequestApprovalConfigs; let i = index">
  
                    <td style="width:0px;">
                      {{i + 1}}
                    </td>
  
                    <td>
                      {{data.designationName}}
                    </td>
  
                    <td>
                      {{data.priority}}
                    </td>
  
                    <td>
                      <label class="custom-control custom-checkbox"><input type="checkbox" value="IsByDepartment"
                        [checked]="data.isByDepartment" disabled /></label>
                    </td>
  
                    <td>
                      <label class="custom-control custom-checkbox"><input type="checkbox" value="IsByLocation"
                        [checked]="data.isByLocation" disabled /></label>
                    </td>
  
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
  
      
    </div>
  </div>